<template>
  <div class="space-between mt-2 flex w-full items-center">
    <p v-if="total" class="text-sm text-gray-700">
      Viser
      <span class="font-medium">{{ showingFrom }}</span>
      til
      <span class="font-medium">{{ showingTo }}</span>
      af
      <span class="font-medium">{{ total }}</span>
      resultater
    </p>
    <nav class="ml-auto flex items-center text-sm text-gray-500">
      <button v-show="currentPage > 1" type="button" class="flex items-center rounded-sm p-2 hover:bg-gray-50" @click="$emit('change', currentPage - 1)">
        <svgicon name="chevron-left" />
      </button>
      <component
        :is="item ? 'button' : 'span'"
        v-for="(item, index) in pagination"
        :key="index"
        class="flex items-center rounded-sm px-4 py-2 hover:bg-gray-50 disabled:hover:bg-blue-50"
        :class="[item === currentPage && 'bg-blue-50 font-medium text-blue-600']"
        :disabled="item === currentPage"
        @click="item && $emit('change', item)"
      >
        {{ item || "..." }}
      </component>
      <button v-show="currentPage < pagesTotal" type="button" class="flex items-center rounded-sm p-2 hover:bg-gray-50" @click="$emit('change', currentPage + 1)">
        <svgicon name="chevron-right" />
      </button>
    </nav>
  </div>
</template>

<script>
export default {
  props: {
    total: {
      type: Number,
      required: false,
    },

    perPage: {
      type: Number,
      default: 20,
    },

    currentPage: {
      type: Number,
      required: true,
    },
  },

  emits: ["change"],

  computed: {
    pagesTotal() {
      return Math.ceil(this.total / this.perPage);
    },

    showingFrom() {
      return this.total ? (this.currentPage - 1) * this.perPage + 1 : 0;
    },

    showingTo() {
      if (!this.total) return 0;

      return this.currentPage < this.pagesTotal ? this.currentPage * this.perPage : this.total;
    },

    pagination() {
      const pagination = [];

      for (let i = 1; i <= this.pagesTotal; i++) {
        pagination.push(i);
      }

      if (this.pagesTotal > 6) {
        if (this.currentPage <= 3 || this.currentPage >= this.pagesTotal - 2) {
          pagination.splice(3, this.pagesTotal - 6);
          pagination.splice(3, 0, null);
        } else {
          pagination.splice(1, this.pagesTotal - 2);
          pagination.splice(1, 0, null, this.currentPage - 1, this.currentPage, this.currentPage + 1, null);
        }
      }

      return pagination;
    },
  },
};
</script>
